<template>
    <div class="revenue-warp">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">收费日报</el-menu-item>
            <el-menu-item index="2">收费单据</el-menu-item>
            <el-menu-item index="3">收费明细</el-menu-item>
            <el-menu-item index="4">收费员统计</el-menu-item>
            <el-menu-item index="5">欠费订单</el-menu-item>
            <el-menu-item index="6">失败订单（推雨诺）</el-menu-item>
        </el-menu>
        <div class="content-warp">
            <chargeDaily v-if="activeIndex == '1'"></chargeDaily>
            <chargeReceipts v-if="activeIndex == '2'"></chargeReceipts>
            <chargeDetail v-if="activeIndex == '3'"></chargeDetail>
            <collectorStatistics v-if="activeIndex == '4'"></collectorStatistics>
            <arrearageOrder v-if="activeIndex == '5'"></arrearageOrder>
            <failOrder v-if="activeIndex == '6'"></failOrder>
        </div>
    </div>
</template>
  
<script>
import chargeDaily from './component/chargeDaily'
import chargeReceipts from './component/chargeReceipts.vue'
import chargeDetail from './component/chargeDetail.vue'
import arrearageOrder from './component/arrearageOrder.vue'
import collectorStatistics from './component/collectorStatistics.vue'
import failOrder from './component/failOrder.vue'
export default {
    // 定义引入的组件
    components: { chargeDaily, chargeReceipts, chargeDetail,arrearageOrder, collectorStatistics,failOrder },
    props: {},
    data() {
        return {
            activeIndex: '1'
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() { },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 切换tab
         */
        handleSelect(val) {
            this.activeIndex = val
        },

    },
}
</script>
<style lang="less" scoped src="./index.less"></style>